import { Spin } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { getMyEnterpriseList } from '../../api/constlink';
import MyEnterpriseListComponent from '../../components/enterprises/MyEnterpriseListComponent';
import { RootState } from '../../modules';
import { Enterprise, EnterpriseType1 } from '../../modules/auth';

function MyEnterpriseListContainer({ history }: RouteComponentProps) {
  const [enterprises, setEnterprises] = useState<Enterprise[] | null>(null);
  const user = useSelector((state: RootState) => state.auth.auth.data);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const moveToMain = async (enterprise: Enterprise) => {
    if (!user) {
      history.goBack();
      return;
    }

    if (enterprise.type1 === EnterpriseType1.CONTRACTOR) {
      history.push(`/enterprises/${enterprise.id}/main`);
      return;
    }

    if (enterprise.type1 === EnterpriseType1.MATERIAL_VENDOR) {
      history.push(`/enterprises/${enterprise.id}/bidChances`);
      return;
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setError(null);
        setEnterprises(null);
        setLoading(true);
        const response = await getMyEnterpriseList();
        setEnterprises(response.enterprises);
      } catch (e: any) {
        console.error(e);
        setError(e);
      }
      setLoading(false);
    };

    fetchUsers();
  }, []);

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러가 발생했습니다</p>}
      {enterprises && (
        <MyEnterpriseListComponent
          enterprises={enterprises}
          moveToMain={moveToMain}
        />
      )}
    </>
  );
}

export default withRouter(MyEnterpriseListContainer);
